"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryResource = void 0;
/**
 * Inventory (TZ §29-§31).
 *
 * Quantities cross the wire as strings. They are NUMERIC in Postgres, and
 * routing them through a JSON number would reintroduce exactly the float drift
 * the column type exists to avoid — so this sends strings and expects them
 * back.
 */
class InventoryResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /* ------------------------------ Suppliers ------------------------- */
    listSuppliers() {
        return this.http.get('suppliers');
    }
    createSupplier(payload) {
        return this.http.post('suppliers', payload);
    }
    updateSupplier(id, payload) {
        return this.http.patch(`suppliers/${id}`, payload);
    }
    /* --------------------------- Purchase orders ---------------------- */
    listOrders(query) {
        return this.http.get('supplier-orders', { query });
    }
    /** Prices are the server's estimate; send what is wanted, not what it costs. */
    createOrder(payload) {
        return this.http.post('supplier-orders', payload);
    }
    /** What actually arrived, with invoice costs, use-by dates and batches. */
    receiveOrder(id, lines) {
        return this.http.post(`supplier-orders/${id}/receive`, { lines });
    }
    cancelOrder(id) {
        return this.http.post(`supplier-orders/${id}/cancel`);
    }
    resendOrder(id) {
        return this.http.post(`supplier-orders/${id}/resend`);
    }
    /* ----------------------------- Stock-takes ------------------------ */
    listTakes(branchId) {
        return this.http.get('stock/takes', { query: { branchId } });
    }
    /** Counted figures; the server compares them with the books and corrects. */
    createTake(payload) {
        return this.http.post('stock/takes', payload);
    }
    /** Batches with stock estimated left, soonest use-by first. */
    listBatches(query) {
        return this.http.get('stock/batches', { query });
    }
    insight(stockItemId) {
        return this.http.get(`stock/items/${stockItemId}/insight`);
    }
    /* -------------------------------- Stock --------------------------- */
    /** What is low, what the shelves are worth, what has been wasted. */
    summary(branchId, days) {
        return this.http.get('stock/summary', { query: { branchId, days } });
    }
    listItems(query) {
        return this.http.get('stock/items', { query });
    }
    getItem(id) {
        return this.http.get(`stock/items/${id}`);
    }
    createItem(payload) {
        return this.http.post('stock/items', payload);
    }
    /**
     * Note what this cannot change: the quantity.
     *
     * A level moves only through a movement, so no call changes a figure without
     * leaving a row explaining why.
     */
    updateItem(id, payload) {
        return this.http.patch(`stock/items/${id}`, payload);
    }
    removeItem(id) {
        return this.http.delete(`stock/items/${id}`);
    }
    listMovements(query) {
        return this.http.getPaginated('stock/movements', { query });
    }
    /** Receipt, waste, adjustment or transfer. Consumption is automatic. */
    addMovement(payload) {
        return this.http.post('stock/movements', payload);
    }
    /* ------------------------------- Recipes -------------------------- */
    /** A dish's ingredients, what it costs to make, and the margin. */
    getRecipe(productId) {
        return this.http.get(`products/${productId}/recipe`);
    }
    /** Replaced wholesale — send the complete list. */
    setRecipe(productId, ingredients) {
        return this.http.patch(`products/${productId}/recipe`, { ingredients });
    }
}
exports.InventoryResource = InventoryResource;
//# sourceMappingURL=inventory.js.map